<template>
  <div>
    <!-- Help button for keyboard shortcuts -->
    <div class="keyboard-help">
      <b-button
        type="is-light"
        size="is-small"
        icon-left="keyboard"
        @click="isKeyboardHelpActive = true"
      >
        Keyboard Shortcuts
      </b-button>
    </div>

    <!-- Keyboard shortcuts modal -->
    <b-modal :active.sync="isKeyboardHelpActive" has-modal-card>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">
            <b-icon icon="keyboard" size="is-small"></b-icon>
            <span class="ml-2"> Keyboard Shortcuts</span>
          </p>
          <button
            class="delete"
            aria-label="close"
            @click="isKeyboardHelpActive = false"
          ></button>
        </header>
        <section class="modal-card-body p-0">
          <table class="table is-fullwidth">
            <thead>
              <tr>
                <th>Key</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(shortcuts, group) in shortcutsMap">
                <tr :key="group + '-header'">
                  <td colspan="2" class="has-text-weight-bold">{{ group }}</td>
                </tr>
                <tr v-for="(action, key) in shortcuts" :key="group + key">
                  <td>
                    <template v-for="k in key.split('/')">
                      <kbd :key="k" class="mr-1">{{ k.trim() }}</kbd>
                    </template>
                  </td>
                  <td>{{ action }}</td>
                </tr>
              </template>
              <!-- Default shortcut -->
              <tr>
                <td><kbd>?</kbd> <kbd>/</kbd></td>
                <td>Show keyboard shortcuts</td>
              </tr>
            </tbody>
          </table>
        </section>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "KeyboardShortcutsHelp",

  props: {
    shortcutsMap: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      isKeyboardHelpActive: false,
    };
  },

  methods: {
    handleKeyDown(event) {
      // Don't trigger if user is typing in an input field
      if (
        event.target.tagName === "INPUT" ||
        event.target.tagName === "TEXTAREA"
      ) {
        return;
      }

      // Show help on either '?' or '/'
      if (event.key === "?" || event.key === "/") {
        event.preventDefault();
        this.isKeyboardHelpActive = !this.isKeyboardHelpActive;
      }
    },
  },

  mounted() {
    window.addEventListener("keydown", this.handleKeyDown);
  },

  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKeyDown);
  },
};
</script>

<style scoped>
.keyboard-help {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
}

/* Style for keyboard keys */
kbd {
  background-color: #f7f7f7;
  border: 1px solid #ccc;
  border-radius: 3px;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.2);
  color: #333;
  display: inline-block;
  font-family: monospace;
  font-size: 0.85em;
  font-weight: 700;
  line-height: 1;
  padding: 0.2em 0.4em;
  white-space: nowrap;
}
</style>
